import { useTranslation } from 'react-i18next';

export default function ComparisonTable() {
  const { t } = useTranslation();

  const rows = [
    { feature: t('comparison.f1'), spreadsheet: true, standard: false },
    { feature: t('comparison.f2'), spreadsheet: true, standard: t('comparison.limited') as string },
    { feature: t('comparison.f3'), spreadsheet: true, standard: false },
    { feature: t('comparison.f4'), spreadsheet: t('comparison.high') as string, standard: t('comparison.low') as string },
    { feature: t('comparison.f5'), spreadsheet: true, standard: false },
    { feature: t('comparison.f6'), spreadsheet: t('comparison.regular') as string, standard: t('comparison.rare') as string },
  ];

  const renderValue = (val: boolean | string) => {
    if (typeof val === 'boolean') {
      return val
        ? <i className="ri-check-line text-accent-600 text-lg font-bold"></i>
        : <i className="ri-close-line text-foreground-300 text-lg"></i>;
    }
    return <span className="text-sm font-medium text-foreground-700">{val}</span>;
  };

  return (
    <section className="w-full bg-background-100/50">
      <div className="w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4 text-center">
            {t('comparison.title')}
          </h2>
          <p className="text-base text-foreground-600 text-center mb-12 max-w-xl mx-auto">
            Zobacz, dlaczego Kakobuy Spreadsheet to najlepsze narzędzie do znajdowania produktów
          </p>

          <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl overflow-hidden border border-background-200/50">
            <div className="grid grid-cols-12 bg-secondary-50 px-6 py-4">
              <div className="col-span-5">
                <span className="text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t('comparison.feature')}</span>
              </div>
              <div className="col-span-4">
                <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">{t('comparison.spreadsheet')}</span>
              </div>
              <div className="col-span-3">
                <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">{t('comparison.standard')}</span>
              </div>
            </div>

            {rows.map((row, idx) => (
              <div key={idx} className={`grid grid-cols-12 px-6 py-4 items-center ${idx < rows.length - 1 ? 'border-b border-background-200/40' : ''}`}>
                <div className="col-span-5">
                  <span className="text-sm font-medium text-foreground-800">{row.feature}</span>
                </div>
                <div className="col-span-4 flex items-center gap-2">
                  {renderValue(row.spreadsheet)}
                </div>
                <div className="col-span-3">
                  {renderValue(row.standard)}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-6 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>{t('cta.button')}</span>
              <span className="w-7 h-7 flex items-center justify-center bg-background-50/20 rounded-full group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}